export const wpFootnoteClass = 'cdm-footnote-container';
export const collectionKey = 'Footnote';
